$(document).ready(function() {
    localStorage.getItem("RedirectionOnCheckOutPage") == "true" && (clearcart(),
    $(".header-cart .cart-summary").remove(),
    $(".header-cart .header-cart__count").text(0),
    localStorage.setItem("RedirectionOnCheckOutPage", "false")),
    $(".itg_remove").click(function() {
        $(".ITGItemSelected").each(function(index, value) {
            let productHandle = $(value).attr("product-handle");
            localStorage.removeItem(`bundle ${productHandle}`)
        }),
        $(".bundle_cart_main_sec").html(" "),
        $(".cstm-addtocart-btn input").prop("checked", !1);
        var selectedItemCount = $(".cstm-addtocart-btn input:checked").length;
        console.log(selectedItemCount);
        var totalItemCount = $(".cstm-addtocart-btn input").length
          , selectedBundleItemCount = $(document).find(".bundle_cart_main_sec .ITGItemSelected").length;
        console.log(selectedBundleItemCount),
        selectedItemCount == selectedBundleItemCount && ($(".ITG_Product_description").find(".qtybox input").val(0).attr("value", 0),
        $(".ITG_Product_description").find(".DefaultAddBtn").prop("checked", !1)),
        $(".ITG_Product_description .qtybox").hide(),
        $(".ITG_Product_description .cstm-addtocart-btn").show(),
        $(".ITG_Product_description .cstm-addtocart-btn input").val(""),
        $(".ITG_Product_description .cstm-addtocart-btn input").attr("value", ""),
        variantOption(),
        nextTarget()
    }),
    loadStoredData(),
    loadStoredValues(),
    $(document).on("change", ".product-form__input input", function() {
        var thisValue = $(".product-form__input input:checked").val()
          , previousTarget = parseInt($(document).find(".count_select").html())
          , currentTargetproduct = parseInt($(document).find(".quantity-content").html());
        variantOption() >= currentTargetproduct ? (variantOption(),
        $(".dot").removeClass("highlight"),
        variantOption() <= 6 ? ($('.product-form__input input[value="6 Jigglys"]').trigger("click").prop("checked", !0),
        $('.dot[data-value="6"]').addClass("highlight"),
        $(document).find(".count_select").text(6)) : variantOption() <= 15 ? ($('.product-form__input input[value="15 Jigglys"]').trigger("click").prop("checked", !0),
        $('.dot[data-value="15"]').addClass("highlight"),
        $(document).find(".count_select").text(15)) : variantOption() <= 30 ? ($('.product-form__input input[value="30 Jigglys"]').trigger("click").prop("checked", !0),
        $('.dot[data-value="30"]').addClass("highlight"),
        $(document).find(".count_select").text(30)) : ($('.product-form__input input[value="50 Jigglys"]').trigger("click").prop("checked", !0),
        $('.dot[data-value="50"]').addClass("highlight"),
        $(document).find(".count_select").text(50))) : ($(document).find(".WarningAlertPopup").css("display", "flex"),
        $(document).find(".currentselectedVal").text(variantOption()),
        $(document).find(".alreadyselectedval").text(currentTargetproduct),
        $(".dot").removeClass("highlight"),
        previousTarget <= 6 ? ($('.product-form__input input[value="6 Jigglys"]').trigger("click").prop("checked", !0),
        $('.dot[data-value="6"]').addClass("highlight"),
        $(document).find(".count_select").text(6)) : previousTarget <= 15 ? ($('.product-form__input input[value="15 Jigglys"]').trigger("click").prop("checked", !0),
        $('.dot[data-value="15"]').addClass("highlight"),
        $(document).find(".count_select").text(15)) : previousTarget <= 30 ? ($('.product-form__input input[value="30 Jigglys"]').trigger("click").prop("checked", !0),
        $('.dot[data-value="30"]').addClass("highlight"),
        $(document).find(".count_select").text(30)) : ($('.product-form__input input[value="50 Jigglys"]').trigger("click").prop("checked", !0),
        $('.dot[data-value="50"]').addClass("highlight"),
        $(document).find(".count_select").text(50))),
        updateCartButton(totalQuantity),
        nextTarget();
       var id = $(this).data('option-value-id'); // use .data() instead of .attr()
  console.log(id);
  $('.product-variant-id').val(id);
    }),
     $(".DefaultAddBtn").on("click", function () {
     // $(this).closest('.cstm-addtocart-btn').hide();
     // $(this).closest('.ITG_Product_description').find('.qtybox').show();
     // $(this).closest('.ITG_Product_description').find('.qtybox input').val(1).attr('value',1)
     // apendData($(this));
     //  nextTarget();

    // ============================ code by (R) start=============================== //
    const quantityElement = document.querySelector(".quantity-content");
    const quantity = parseInt(quantityElement?.textContent.trim() || "0", 10);
    if (quantity != 50 && quantity < 50) {
         $(this).closest('.cstm-addtocart-btn').hide();
         $(this).closest('.ITG_Product_description').find('.qtybox').show();
         $(this).closest('.ITG_Product_description').find('.qtybox input').val(1).attr('value',1)
         apendData($(this));
          nextTarget();
        }else{
          alert('Total quantity cannot exceed 50.');
           if (this.checked) {
                this.checked = false;
             // this.setAttribute('value', '');
            }
        }
// ============================ code by (R) End=============================== //
 });

    $(document).on("click", ".ITGQtyAdjust", function() {
        adjustQty($(this)),
        nextTarget()
    });
    function clearcart() {
        console.log("cart function"),
        $.ajax({
            type: "POST",
            url: "/cart/clear.js",
            data: "",
            dataType: "json",
            success: function() {},
            error: function(XMLHttpRequest, textStatus) {}
        })
    }
    function apendData(element, event) {
        var productImage = element.attr("data_img")
          , productTitle = element.attr("title")
          , productHandle = element.attr("dataval")
          , QtyInput = element.closest(".ITG_Product_description").find(".qtydiv").html()
          , MainQty = element.closest(".ITG_Product_description").find(".qtydiv input").val();
        if (element.is(":checked"))
            var inputchecked = !0;
        else
            var inputchecked = !1;
        var removeBtn = "";
        if ($(".bundle_cart_main_sec").find(`[product-handle="${productHandle}"]`).length === 0) {
            var productsData = `
      <div class="ITGItemSelected" product-handle="${productHandle}">
        <div class="product-info">
          <img src='${productImage}' alt="Product Image">
          <p>${productTitle}</p>
        </div>
        <div class="selectedItemQty">${QtyInput}</div>
        ${removeBtn}
      </div>`;
            productHandle === "Jigglys" ? $(".bundle_cart_main_sec").append(productsData) : $(".bundle_cart_main_sec").prepend(productsData),
            event != "onload" && localStorage.setItem(`bundle ${productHandle}`, `${MainQty}&&${inputchecked}`),
            $(".ITGItemSelected .selectedItemQty input").each(function() {
                let getQuanty = localStorage.getItem(`bundle ${productHandle}`).split("&&")
                  , getQuantityLS = parseInt(getQuanty[0]);
                productHandle == $(this).attr("data-id") && $(this).val(getQuantityLS)
            })
        }
    }
    function adjustQty(target) {
        var opration = target.attr("btnfor")
          , productHandle = target.closest(".qtybox").find("input").attr("data-id")
          , productTitle = target.closest(".qtybox").attr("data-title")
          , quantityInput = $(`.quantity-input[data-id='${productHandle}']`)
          , quantity = parseInt(quantityInput.val())
          , totalSelectedItemsCount = 0;
        if ($(".ITG_Product_description").find(".qtybox input").each(function() {
            totalSelectedItemsCount += parseInt($(this).val())
        }),
        opration == "minus")
            quantity--;
        else {
            if (totalSelectedItemsCount >= 50) {
                alert("Total quantity cannot exceed 50.");
                return
            }
            quantity++
        }
        quantityInput.val(quantity).attr("value", quantity);
        var hiddenInput = $(`.product-block.col_bundle_sec[data-id='${productHandle}'] .cs-line-item-property__field.cstm-addtocart-btn input`)
          , newValue = `${quantity}*${productTitle}`;
        quantity <= 0 ? ($(document).find(`.cstm-addtocart-btn:has([dataval="${productHandle}"])`).show(),
        $(document).find(`.cstm-addtocart-btn:has([dataval="${productHandle}"])`).find("input").prop("checked", !1),
        $(document).find(`.qtybox:has([data-id="${productHandle}"])`).hide(),
        $(document).find(`.bundle_cart_main_sec [product-handle='${productHandle}']`).remove(),
        hiddenInput.val(""),
        localStorage.removeItem(`bundle ${productHandle}`)) : (hiddenInput.val(newValue),
        localStorage.setItem(`bundle ${productHandle}`, `${quantity}&&true`))
    }
    function nextTarget(target) {
        var totalSelectedItemsCount = 0;
        $(".ITG_Product_description").find(".qtybox input").each(function() {
            var ThisItemCount = parseInt($(this).val());
            totalSelectedItemsCount += ThisItemCount
        }),
        $(document).find(".quantity-content").text(totalSelectedItemsCount),
        $(".dot").removeClass("highlight"),
        totalSelectedItemsCount <= 6 ? ($('.product-form__input input[value="6 Jigglys"] + label').trigger("click").prop("checked", !0),
        $('.dot[data-value="6"]').addClass("highlight"),
        $(document).find(".count_select").text(6)) : totalSelectedItemsCount <= 15 ? ($('.product-form__input input[value="15 Jigglys"] + label').trigger("click").prop("checked", !0),
        $('.dot[data-value="15"]').addClass("highlight"),
        $(document).find(".count_select").text(15)) : totalSelectedItemsCount <= 30 ? ($('.product-form__input input[value="30 Jigglys"] + label').trigger("click").prop("checked", !0),
        $('.dot[data-value="30"]').addClass("highlight"),
        $(document).find(".count_select").text(30)) : ($('.product-form__input input[value="50 Jigglys"] + label').trigger("click").prop("checked", !0),
        $('.dot[data-value="50"]').addClass("highlight"),
        $(document).find(".count_select").text(50)),
        updateCartButton(totalSelectedItemsCount)
    }
    function updateCartButton(totalQuantity) {
        let variant_price = $(".product-form__input input:checked").attr("variant_price");
        totalQuantity == 6 || totalQuantity == 15 || totalQuantity == 30 || totalQuantity == 50 ? ($(".custom-add-to_cart").addClass("add-to_cart-disabled"),
        $(".custom-add-to_cart").text("In den Warenkorb - " + variant_price),
        $(".Srm-quantity_box-add").hide(),
        $(".Srm_desk_qty").show()) : ($(".custom-add-to_cart").removeClass("add-to_cart-disabled"),
        $(".custom-add-to_cart").html('<span>Please select at least <span class="count_select">15</span> products</span>'),
        $(".Srm-quantity_box-add").show(),
        $(".Srm_desk_qty").hide()),
        totalQuantity >= 1 && totalQuantity < 7 && ($('.dot[data-value="15"]').removeClass("highlight"),
        $('.dot[data-value="6"]').addClass("highlight"),
        $('.product-form__input input[value="6 Jigglys"]').trigger("click"),
        $("span.count_select").text("6")),
        totalQuantity >= 7 && totalQuantity < 16 && ($('.dot[data-value="6"]').removeClass("highlight"),
        $('.dot[data-value="15"]').addClass("highlight"),
        $('.product-form__input input[value="15 Jigglys"]').trigger("click"),
        $("span.count_select").text("15")),
        totalQuantity >= 16 && totalQuantity < 31 && ($('.dot[data-value="6"]').removeClass("highlight"),
        $('.dot[data-value="15"]').removeClass("highlight"),
        $('.dot[data-value="30"]').addClass("highlight"),
        $('.product-form__input input[value="30 Jigglys"]').trigger("click"),
        $("span.count_select").text("30")),
        totalQuantity >= 31 && totalQuantity <= 50 && ($('.dot[data-value="6"]').removeClass("highlight"),
        $('.dot[data-value="15"]').removeClass("highlight"),
        $('.dot[data-value="30"]').removeClass("highlight"),
        $('.dot[data-value="50"]').addClass("highlight"),
        $('.product-form__input input[value="50 Jigglys"]').trigger("click"),
        $("span.count_select").text("50"))
    }
    function variantOption() {
        var targetQuantity = 0;
        const selectedVariant = $(".product-form__input input:checked").val();
        return selectedVariant === "6 Jigglys" ? targetQuantity = 6 : selectedVariant === "15 Jigglys" ? targetQuantity = 15 : selectedVariant === "30 Jigglys" ? targetQuantity = 30 : selectedVariant === "50 Jigglys" && (targetQuantity = 50),
        $(document).find(".count_select").text(targetQuantity),
        targetQuantity
    }
    function resetBundle() {
        var selectedItemCount = $(".cstm-addtocart-btn input:checked").length
          , totalItemCount = $(".cstm-addtocart-btn input").length
          , selectedBundleItemCount = $(document).find(".bundle_cart_main_sec .ITGItemSelected").length;
        selectedItemCount == selectedBundleItemCount && selectedBundleItemCount == totalItemCount && ($(".ITG_Product_description").find(".qtybox input").val(0).attr("value", 0),
        $(".ITG_Product_description").find(".DefaultAddBtn").prop("checked", !1)),
        console.log(`${selectedItemCount} == ${totalItemCount}== ${selectedBundleItemCount}`)
    }
    $(document).on("click", ".random-button", function() {
        var currentTargetproducts = parseInt($(document).find(".quantity-content").html())
          , countTargetproducts = parseInt($(document).find(".count_select").html());
        if (currentTargetproducts === countTargetproducts || currentTargetproducts === countTargetproducts || currentTargetproducts === countTargetproducts || currentTargetproducts === countTargetproducts)
            return;
        let productHandles = [];
        $(".bundle_cart_main_sec .ITGItemSelected").each(function() {
            productHandles.push($(this).attr("product-handle"))
        }),
        resetBundle(),
        $(".bundle_cart_main_sec").html("");
        let productCount = {}
          , totalProductsAdded = 0;
        variantOption();
        var itemsfixCount = 0;
        $(document).find(".cstm-addtocart-btn input:checked").each(function() {
            var itemsfix = parseInt($(this).closest(".ITG_Product_description").find(".qtybox input").val());
            itemsfixCount += itemsfix,
            apendData($(this))
        });
        var remainingQty = variantOption() - itemsfixCount;
        if (remainingQty > 0) {
            var mysteryProduct = $(document).find('.cstm-addtocart-btn input[dataval="jigglys"]');
            mysteryProduct.closest(".cstm-addtocart-btn").hide(),
            mysteryProduct.closest(".ITG_Product_description").find(".qtybox").show(),
            mysteryProduct.closest(".ITG_Product_description").find(".qtybox input").val(remainingQty).attr("value", remainingQty),
            apendData(mysteryProduct)
        }
        reorderProducts(productHandles),
        $(document).find(".cs-line-item-property__field").each(function() {
            var inputField = $(this).find("input");
            if ($(this).closest(".product-block.cstm_product.col_bundle_sec").find(".product-block__title-link").text().trim() === "Mystery Jigglys") {
                var productTitle = "Mystery Jigglys"
                  , newValue = remainingQty + "*" + productTitle;
                inputField.val(newValue).attr("value", newValue)
            }
        }),
        nextTarget()
    });
    function reorderProducts(productHandles) {
        productHandles.forEach(handle => {
            var productElement = $(".bundle_cart_main_sec").find(`[product-handle="${handle}"]`);
            productElement.length && productElement.detach().appendTo(".bundle_cart_main_sec")
        }
        );
        var mysteryProduct = $(".bundle_cart_main_sec").find('[product-handle="Jigglys"]');
        mysteryProduct.length && mysteryProduct.detach().appendTo(".bundle_cart_main_sec")
    }
    $("#create-your-bundle .cstm-tab-btn").click(function() {
        clearPreviousTabValues(),
        $(".quantity-input").val(0),
        $(".bundle_cart_main_sec").html("");
        let tagName = $(this).attr("data-tab-content")
          , productCount = {}
          , totalProductsAdded = 0;
        var productId = $(this).closest(".col_bundle_sec").find(".qtydiv").attr("data-id");
        let maxProducts = 0;
        const selectedVariant = $(".product-form__input input:checked").val();
        if (console.log(`Selected Variant: ${selectedVariant}`),
        selectedVariant === "6 Jigglys" ? maxProducts = 6 : selectedVariant === "15 Jigglys" ? maxProducts = 15 : selectedVariant === "30 Jigglys" ? maxProducts = 30 : selectedVariant === "50 Jigglys" && (maxProducts = 50),
        $(".product-block.col_bundle_sec").each(function() {
            let proTag = $(this).data("tab-tag");
            var productId2 = $(this).find(".qtydiv").attr("data-id");
            if (totalProductsAdded >= maxProducts)
                return !1;
            if (proTag.includes(tagName)) {
                $(this).find(".cstm-addtocart").trigger("click"),
                $(this).find(".quantity-selector").val(1),
                productCount[productId2] = (productCount[productId2] || 0) + 1,
                totalProductsAdded++,
                apendData($(this).find(".cstm-addtocart-btn input"));
                var qtyValue = parseInt($(this).find(".quantity-selector").val());
                qtyValue > 0 ? ($(this).find(".cstm-addtocart-btn").hide(),
                $(this).find(".qtybox").show()) : ($(this).find(".cstm-addtocart-btn").show(),
                $(this).find(".qtybox").hide())
            } else
                $(this).find(".quantity-selector").val(0),
                $(this).find(".cstm-addtocart-btn").show(),
                $(this).find(".qtybox").hide()
        }),
        $(".cstm-addtocart-btn input").each(function() {
            var $checkbox = $(this)
              , $productBlock = $checkbox.closest(".product-block.col_bundle_sec")
              , $quantitySelector = $productBlock.find(".quantity-selector");
            if ($quantitySelector.val() == 0 || !$checkbox.prop("checked")) {
                $checkbox.prop("checked", !1),
                $checkbox.val("");
                var hiddenInput2 = $productBlock.find(".cs-line-item-property__field.cstm-addtocart-btn input");
                hiddenInput2.val("")
            }
        }),
        totalProductsAdded < maxProducts) {
            var availableProductIds = Object.keys(productCount)
              , availableProductCount = availableProductIds.length;
            for (let i2 = totalProductsAdded; i2 < maxProducts; i2++) {
                var productIdToAdd = availableProductIds[i2 % availableProductCount];
                productCount[productIdToAdd] = (productCount[productIdToAdd] || 0) + 1,
                totalProductsAdded++
            }
        }
        for (var productId in productCount) {
            var quantityInput = $(`.quantity-input[data-id="${productId}"]`);
            if (quantityInput.length > 0) {
                var productTitle = $(`.product-block.col_bundle_sec[data-id="${productId}"] .qtybox`).attr("data-title")
                  , newValue = `${productCount[productId]}*${productTitle}`
                  , newIntValue = parseInt(productCount[productId]);
                quantityInput.val(newIntValue),
                quantityInput.attr("value", newIntValue);
                var hiddenInput = $(`.product-block.col_bundle_sec[data-id="${productId}"] .cs-line-item-property__field.cstm-addtocart-btn input`);
                hiddenInput.val(newValue),
                localStorage.setItem(`bundle ${productId}`, `${productCount[productId]}&&true`)
            }
        }
        $("#create-your-bundle .cstm-tab-btn").removeClass("new-class"),
        $(this).addClass("new-class"),
        nextTarget()
    });
    function loadStoredValues() {
        $(document).find(".quantity-input").each(function() {
            var productId = $(this).attr("data-id")
              , storedValue = localStorage.getItem(`bundle ${productId}`);
            if (storedValue) {
                var parts = storedValue.split("&&")
                  , quantity = parts[0]
                  , checked = parts[1] === "true";
                if (quantity != 0) {
                    $(this).val(quantity).attr("value", quantity);
                    var hiddenInput = $(`.product-block.col_bundle_sec[data-id="${productId}"] .cs-line-item-property__field.cstm-addtocart-btn input`)
                      , newValue = `${quantity}*${productId}`;
                    hiddenInput.val(newValue),
                    $(document).find(`.qtybox:has([data-id="${productId}"])`).hide()
                }
                quantity > 0 && ($(document).find(`.qtybox:has([data-id="${productId}"])`).show(),
                $(document).find(`.cstm-addtocart-btn:has([dataval="${productId}"])`).hide(),
                $(document).find(`.cstm-addtocart-btn:has([dataval="${productId}"]) input`).prop("checked", checked))
            }
        })
    }
    function clearPreviousTabValues() {
        $(document).find(".quantity-input").each(function() {
            var productId = $(this).attr("data-id");
            localStorage.removeItem(`bundle ${productId}`)
        })
    }
    $(".cstm-addtocart-btn").click(function() {
        var $button = $(this)
          , $productBlock = $button.closest(".product-block.col_bundle_sec")
          , productId = $productBlock.data("id")
          , quantity = parseInt($productBlock.find(".quantity-selector").val())
          , quantityInput = $(`.quantity-input[data-id="${productId}"]`);
        quantityInput.length > 0 && quantityInput.val(quantity);
        var hiddenInput = $productBlock.find(".cs-line-item-property__field.cstm-addtocart-btn input");
        if (quantity != 0)
            var newValue = `${quantity}*${$productBlock.find(".qtybox").attr("data-title")}`;
        newValue === "" || !/\d/.test(newValue) ? hiddenInput.val("") : hiddenInput.val(newValue)
    });
    function loadStoredData() {
        $(".cstm-addtocart-btn input").each(function() {
            var itemHandle = $(this).attr("dataval")
              , storedData = localStorage.getItem(`bundle ${itemHandle}`);
            if (storedData) {
                var storedDataParts = storedData.split("&&");
                if (storedDataParts.length === 2) {
                    var storedDataQty = storedDataParts[0]
                      , storedDataInput = storedDataParts[1];
                    storedDataQty != 0 && ($(this).closest(".ITG_Product_description").find(".qtybox").show(),
                    $(this).closest(".cstm-addtocart-btn").hide(),
                    apendData($(this), "onload"),
                    $(document).find(`.qtybox input[data-id='${itemHandle}']`).val(storedDataQty).attr("value", storedDataQty),
                    nextTarget())
                }
            }
        })
    }
    $(document).on("click", ".ClosePopup", function() {
        $(document).find(".WarningAlertPopup").hide()
    }),
    $(document).on("click", ".custom-add-to_cart.add-to_cart-disabled", function(e) {
        e.preventDefault(),
        $(".custom-add-to_cart").css("opacity", "0.6"),
        $(".custom-add-to_cart").text("Adding to Cart");
        var form = $(this).closest("form")
          , formData = form.serializeArray();
        $(".cs-line-item-property__field input").each(function() {
            var inputName = $(this).attr("name")
              , inputValue = $(this).val();
            inputValue && formData.push({
                name: inputName,
                value: inputValue
            })
        });
        var quantityInput = form.find('input[name="quantity"]');
        quantityInput.length > 0 && quantityInput.val() !== "1" && formData.push({
            name: "quantity",
            value: "1"
        }),
        $.ajax({
            type: "POST",
            url: "/cart/add.js",
            dataType: "json",
            data: $.param(formData),
            success: function() {
                $(".custom-add-to_cart").text("Added to Cart"),
                setTimeout(function() {
                    window.location = "/cart"
                }, 1e3)
            },
            error: function(XMLHttpRequest, textStatus) {
                var response = JSON.parse(XMLHttpRequest.responseText)
            }
        })
    }),
    $("input#B_open-search-bar").on("keyup", function() {
        var value = $(this).val().toLowerCase();
        $(".product-block.col_bundle_sec").filter(function() {
            $(this).toggle($(this).attr("sp_title").toLowerCase().indexOf(value) > -1)
        })
    }),
    $(".src_filter_tag_flx").click(function(event) {
        event.stopPropagation(),
        $(".searc_bar_filter_tg").fadeToggle()
    }),
    $("body").click(function(event) {
        $(event.target).closest(".searc_bar_filter_tg, .src_filter_tag_flx").length || $(".searc_bar_filter_tg").hide()
    }),
    $(".searc_bar_filter_tg").click(function(event) {
        event.stopPropagation()
    }),
    $(".searc_bar_filter_tg ul.product-tags li").on("click", function() {
        var li_tag = $(this).attr("Pgtag").toLowerCase()
          , li_text = $(this).text();
        $(this).closest(".searc_bar_filter").find(".src_filter_tag_flx span").text(li_text),
        $(".product-block.col_bundle_sec").filter(function() {
            var product_tag = $(this).attr("product_tag").toLowerCase();
            return product_tag.indexOf(li_tag) > -1
        }).show(),
        $(".product-block.col_bundle_sec").filter(function() {
            var product_tag = $(this).attr("product_tag").toLowerCase();
            return product_tag.indexOf(li_tag) === -1
        }).hide(),
        $(".searc_bar_filter_tg").hide()
    }),
    $(".view-details a").click(function() {
      event.preventDefault();
        $(this).closest(".product-block.col_bundle_sec").addClass("open-popup")
    }),
    $(".popupclose").click(function() {
        $(this).closest(".product-block.col_bundle_sec").removeClass("open-popup")
    }),
    $(".mobile_sc_arrow").click(function() {
    const $bundleContent = $(this).closest(".cstm-bundle-content");
    $bundleContent.toggleClass("open-popupBar");

    if ($(".open-popupBar").length > 0) {
        // Do something if any open-popupBar is present
        console.log("At least one .open-popupBar is active.");
    } else {
        // Do something else if none are active
        console.log("No .open-popupBar is active.");
    }
});

    $(document).on("click", "span.qtyminus", function() {
        var numItems = $(".product-block.col_bundle_sec.active").length;
        numItems === 0 && $("body").removeClass("Bnd-overflow-hiddan")
    });
    function durationSlider() {
        setInterval(function() {
            var allQuantitiesZero = !0;
            $(".quantity-selector").each(function() {
                if ($(this).val() != 0)
                    return allQuantitiesZero = !1,
                    !1
            }),
            $(".cstm-bundle-product-grid .cstm-addtocart-btn input").is(":checked") || !allQuantitiesZero ? $(".cstm-bundle-main").addClass("popSlidbox") : ($(".cstm-bundle-main").removeClass("popSlidbox"),
            $(".cstm-tab-btn").removeClass("new-class"),
            $(".cstm-bundle-main .cstm-bundle-content").removeClass("open-popupBar"))
        }, 50)
    }
    durationSlider(),
    $(document).on("click", ".custom_addon-item .Remove", function() {
        var dta = $(".add_extra_content_btn input").attr("id");
        $(".new-product.col_bundle_sec.addon_product-box").remove(),
        $(".add_extra_content_btn input").prop("checked", !1);
        var variant_id2 = $(this).closest(".new-product.col_bundle_sec.addon_product-box").attr("first_id");
        $(this).closest(".new-product.col_bundle_sec.addon_product-box").remove(),
        removeAddonProductFromLocalStorage(variant_id2)
    }),
    $(document).on("click", ".addonproductquantity span", function() {
        var quantityInput = $(this).parent().find(".addon-number")
          , currentQuantity = parseInt(quantityInput.val(), 10);
        if ($(this).hasClass("addon-plus"))
            quantityInput.val(currentQuantity + 1);
        else if ($(this).hasClass("addon-minus"))
            if (currentQuantity > 1)
                quantityInput.val(currentQuantity - 1);
            else {
                $(this).closest(".new-product.col_bundle_sec.addon_product-box").remove();
                var bundleSec = $(this).closest(".col_bundle_sec")
                  , productId = bundleSec.attr("data-id");
                return
            }
    });
    function saveAddonProductToLocalStorage(variant_id2, addon_productImage, addonproductTitle) {
        var addonProductData2 = {
            variant_id: variant_id2,
            addon_productImage,
            addonproductTitle
        };
        localStorage.setItem("addonProduct_" + variant_id2, JSON.stringify(addonProductData2))
    }
    function removeAddonProductFromLocalStorage(variant_id2) {
        localStorage.removeItem("addonProduct_" + variant_id2)
    }
    $(".add_extra_content_btn input").on("change", function(evt) {
        evt.preventDefault();
        var dta = $(this).attr("id")
          , addon_productImage = $(".add_extra_media").attr("addon_img")
          , addonproductTitle = $(".add_extra_content h3").text()
          , variant_id2 = $(this).attr("data-id")
          , remove_item = "Remove Item"
          , data = {
            id: variant_id2,
            quantity: 1
        };
        jQuery.ajax({
            type: "POST",
            url: "/cart/add.js",
            data,
            dataType: "json",
            success: function() {
                if ($("#" + dta).is(":checked")) {
                    saveAddonProductToLocalStorage(variant_id2, addon_productImage, addonproductTitle);
                    var newProductHtml2 = `
                        <div class="new-product col_bundle_sec addon_product-box" first_id="${variant_id2}">
                            <div class="productimage-box test add to cart">
                                <img src="${addon_productImage}" alt="Product Image">
                                  <div class="custom_addon-item">
                                        <h3>${addonproductTitle}</h3>
                                        <div class="Remove">${remove_item}</div>
                                  </div>
                            </div>
                          
                        </div>
                    `;
                    $(".bundle_cart_main_sec").append(newProductHtml2)
                } else
                    $(this).parent().parent().removeClass("active"),
                    $('.new-product.col_bundle_sec.addon_product-box[first_id="' + variant_id2 + '"]').remove(),
                    removeAddonProductFromLocalStorage(variant_id2)
            },
            error: function(xhr, status, error) {
                console.error("Error adding item to cart:", status, error)
            }
        })
    });
    for (var i = 0; i < localStorage.length; i++) {
        var key = localStorage.key(i);
        if (key.startsWith("addonProduct_")) {
            var variant_id = key.replace("addonProduct_", "")
              , addonProductData = JSON.parse(localStorage.getItem(key));
            if (addonProductData) {
                var newProductHtml = `
                    <div class="new-product col_bundle_sec addon_product-box" first_id="${addonProductData.variant_id}">
                        <div class="productimage-box test add to cart">
                            <img src="${addonProductData.addon_productImage}" alt="Product Image">
                            <div class="custom_addon-item">
                                <h3>${addonProductData.addonproductTitle}</h3>
                                <div class="Remove">Remove Item</div>
                            </div>
                        </div>
                    </div>
                `;
                $(".bundle_cart_main_sec").append(newProductHtml)
            }
        }
    }
    $(".product-form__input.Color .opt-label").each(function() {
        var labelText = $(this).text().split("$")[0].trim();
        labelText = labelText.replace(/-\s*$/, ""),
        $(this).text(labelText)
    })
}),
document.addEventListener("DOMContentLoaded", function() {
    const check_out_btn = document.querySelector(".cart-submit");
    check_out_btn && check_out_btn.addEventListener("click", () => localStorage.clear()),
    document.querySelectorAll(".cart-item-container").forEach(item => {
        const quantityInput = item.querySelector("input.quantity__number");
        quantityInput && (quantityInput.value = 1)
    }
    )
}),
function() {
    window.onpageshow = function(event) {
        event.persisted && window.location.reload()
    }
}();
//# sourceMappingURL=/cdn/shop/t/36/assets/custom.js.map?v=35426636444722897401736174831
